import React, { Component } from 'react'
import Config from '../Constants/index'

export default class EquipmentLkp extends Component {

    constructor(props) {
        super(props);
        //this.add = this.add.bind(this);
        let id = 0;
        let isEdit = false;
        /* if (this.props.match.params.Id) {
            id = this.props.match.params.Id;
            isEdit = true;
        }*/

/* name="EquipmentRef" onChange={this.onChange} value={this.state.EquipmentRef} */

        //let buildingRef = this.props.match.params.buildingRef;
        this.state = {
            //TODO
            Id: id,
            isEdit: false, 
            Title: '', 
            Short: '', 
            isRedirectEquipment: false,
            CalibrationTypeRef: 1,
            EquipmentRef:-1,
            CalibrationTypes  :[{Id:1,Title:"Pressure"}],
            messages: [], 
            equipments: []
        };

        this.onChange = this.onChange.bind(this);
        this.fetchEquipments = this.fetchEquipments.bind(this);

    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
        this.props.onChange(e);
    }

    componentDidMount() {
        this.fetchEquipments();
    }

    fetchEquipments() {
        this.setState({ loading: true });
        fetch(Config.API_URL + "Equipment/GetEquipmentList/?timestamp=" + new Date().getTime(),
            { headers: { token: window.localStorage.getItem("apiToken") } })
            .then(response => response.json())
            .then(json => {
                this.setState({ equipments: json, loading: false });
                console.log(this.state.equipments);
            });

    }


    render() {
        return (
            <select class="form-control" id="exampleSelect1" name={this.props.name} 
                onChange={this.onChange} >
                <option value={0}>---</option>
                {
                    this.state.equipments.map(function(item){
                        return <option  value={item.id}>{item.description}</option>
                    })
                }
            </select>        
        )
    }
}
